export const STEPS = [
  {
    n: "01",
    title: "Pick the service you need.",
    body: "Browse the catalogue — from a single lift review to a full custom training block. No packages, no upsells.",
  },
  {
    n: "02",
    title: "Send us what we need.",
    body: "Upload the video, log, or brief. Every service tells you exactly what to send.",
  },
  {
    n: "03",
    title: "A qualified coach gets to work.",
    body: "Your submission is matched to a qualified coach with the right expertise. No junior interns, no AI-only answers.",
  },
  {
    n: "04",
    title: "Get your review and move on stronger.",
    body: "You receive a written breakdown, a marked-up video, or a full plan — depending on the service. Come back when you need more.",
  },
];
